module.exports = __webpack_public_path__ + "img/wordpress.e5aa2011.jpg";